module.exports = __webpack_public_path__ + "img/certif_04.a0cfa6e9.jpg";